module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1505-1a43398f71f8ca0961889ed437af9e79.png";